import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import classnames from 'classnames'

const StyledCalendar = styled.div`
  color: var(--boulder);
  border: 1px solid var(--geyser);
  padding: 1px;
  background-color: #e6e9ec;

  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-gap: 1px;
`

export const Calendar = ({ children }) => {
  return <StyledCalendar>{children}</StyledCalendar>
}

Calendar.propTypes = {
  children: PropTypes.node
}

const StyledCalendarHeaderCell = styled.div`
  background-color: var(--pure-white);
  padding: 5px 8px;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
  text-align: left;
`

export const CalendarHeaderCell = ({ children }) => {
  return <StyledCalendarHeaderCell>{children}</StyledCalendarHeaderCell>
}

CalendarHeaderCell.propTypes = {
  children: PropTypes.node
}

const StyledCalendarCell = styled.div`
  max-width: 100%;
  background-color: var(--pure-white);
  min-height: 80px;
  padding-bottom: 10px;
  ${({ active, highlight }) => `
  ${active ? 'cursor:pointer;' : ''}
  ${
    highlight
      ? 'box-shadow: inset 0px 0px 0px 1px #979797;   border-color: #e6e9ec;'
      : ''
  }`}
`

const StyledCalendarDayNumber = styled.span`
  display: inline-block;
  font-family: 'Roboto Condensed', arial, sans-serif;
  margin: 8px;
  padding: 2px;
  color: var(--boulder);
  ${({ active, today, dayOfMonth }) => `
    ${(active) ? '' : 'opacity: 0.3;  text-decoration: line-through;'}
    ${today ? 'border-bottom: 2px solid #ccc; font-weight: 500;' : ''}
    ${dayOfMonth ? '' : 'opacity: 0.3'}
  `}
`

export const CalendarCell = ({
  day,
  dayOfMonth,
  active,
  today,
  children,
  onClick,
  data,
  highlight,
  'data-mu-test': dataAttributeTest
}) => {
  const handleClick = e => (active ? onClick(data) : undefined)
  return (
    <StyledCalendarCell
      active={active}
      highlight={highlight}
      onClick={handleClick}
      data-mu-test={classnames(
        'day',
        { 'day--today': today, 'day--active': active },
        dataAttributeTest
      )}
    >
      <StyledCalendarDayNumber
        active={active}
        dayOfMonth={dayOfMonth}
        today={today}
        data-mu-test={classnames('day-number', {
          'day-number--current-month': dayOfMonth,
          'day-number--today': today
        })}
      >
        {day}
      </StyledCalendarDayNumber>
      {children}
    </StyledCalendarCell>
  )
}

CalendarCell.propTypes = {
  day: PropTypes.string,
  dayOfMonth: PropTypes.bool,
  active: PropTypes.bool,
  today: PropTypes.bool,
  onClick: PropTypes.func,
  data: PropTypes.string,
  highlight: PropTypes.bool,
  children: PropTypes.node,
  'data-mu-test': PropTypes.string
}

const StyledCalendarToolbar = styled.div`
  padding: 15px 25px 12px 25px;
  border: 1px solid var(--geyser);
  margin-bottom: -1px;
  display: flex;
  align-items: center;
`

export const CalendarToolbar = ({ children }) => {
  return <StyledCalendarToolbar>{children}</StyledCalendarToolbar>
}

CalendarToolbar.propTypes = {
  children: PropTypes.node
}
